// Pointing to state.testing because of how it's defined in store.js
export const selectTestingLists = state => state.testing.testingListsData; 
export const selectTestingListsStatus = state => state.testing.status;